<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('settlementUnit.creator')" prop="creator">
                  <!--创建人-->
                  <el-input v-model="queryCondition.creator" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('common.status')" prop="status">
                  <!--状态-->
                  <ic-select clearable table="TM_ENGAGEMENT" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('settlementUnit.systemApplyNumber')" prop="serialNo">
                  <el-input v-model.trim="queryCondition.serialNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('settlementUnit.supplierName')" prop="supplierName">
                  <el-input v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('settlementUnit.supplierCode')" prop="supplierCode">
                    <el-input v-model.trim="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(从)" prop="beginDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.beginDate" type="date" :picker-options="pickerOptionsStart" :placeholder="$t('common.selDate')" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建日期(至)" prop="endDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.endDate" type="date" :picker-options="pickerOptionsEnd" :placeholder="$t('common.selDate')" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <!--el-button type="primary" @click="selectType()" v-acl="QueryEngagementDetail">{{$t('common.newBuilt')}}</el-button -->
    </div>
    <el-table :data="tableList" ref="tableList" row-key="tmEngagementId" border highlight-current-row max-height='420'>
      <el-table-column show-overflow-tooltip prop="serialNo" :label="$t('settlementUnit.systemApplyNumber')">
        <template slot-scope="scope">
          <div class="a-link" @click="selectType(scope.row.tmEngagementId)">{{scope.row.serialNo}}
          </div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('settlementUnit.supplierCode')" width="140"></el-table-column>
      <el-table-column show-overflow-tooltip prop="nameCn" :label="$t('settlementUnit.supplierName')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="creator" :label="$t('settlementUnit.creator')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createDate" :label="$t('settlementUnit.riqi')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="status" :label="$t('settlementUnit.status')"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import { apiService } from "../../../api/settlementUnit/engagement-file";
import { Message } from "element-ui";

export default {
  components: { IcSelect },
  name: "",

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      dataArr: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        creator: null,
        status: null,
        serialNo: null,
        supplierName: null,
        supplierCode: null,
        beginDate: null,
        endDate: null,
      },
      tableList: [],
      totalCount: 0,
      pickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.beginDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    };
  },
  created() {
    this.queryData(1);
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      apiService.search(this.queryCondition).then(res => {
        this.tableList = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    //新建先选择文件类型
    selectType(id) {
      this.$router.push({
        path: `/EngagementDetail`,
        query: { id: id }
      });
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        creator: null,
        status: null,
        serialNo: null,
        supplierName: null,
        supplierCode: null,
        beginDate: null,
        endDate: null,
      }
      this.queryData();
    }
  },
  extends: commonFunction
};
</script>
<style lang="scss">
</style>
